import React from 'react'
import { Table, Spin } from 'antd'
import { useComponentNeighbors } from '../BlockDiagram'
import { useDiagram, useDiagramDispatch } from './DiagramContext'

import { FormattedMessage, injectIntl } from 'react-intl'
import { Loadable } from '../components/Loading'

const columns = [
  {
    title: (
      <FormattedMessage id="functionalDiagrams.componentNeighbours.alias" />
    ),
    dataIndex: 'alias',
    width: '30%',
    ellipsis: true,
  },
  {
    title: (
      <FormattedMessage id="functionalDiagrams.componentNeighbours.description" />
    ),
    dataIndex: 'description',
    ellipsis: true,
    width: '55%',
  },
  {
    title: <FormattedMessage id="functionalDiagrams.componentNeighbours.pin" />,
    dataIndex: 'pin',
    width: '15%',
  },
]

const ComponentNeighbors = ({
  componentId,
  vin,
  showSelection = false,
  pageSize = 6,
}) => {
  const dispatch = useDiagramDispatch()
  const diagram = useDiagram()

  const { isLoading, isSuccess, neighbors } = useComponentNeighbors({
    vin,
    componentId,
  })

  return (
    <>
      <Loadable showText={false} isLoading={isLoading}>
        <Table
          rowSelection={
            showSelection && {
              type: 'radio',
              onSelect: (record, selected, selectedRows, nativeEvent) => {
                dispatch.detailDiagram.handleComponentNeighborSelection({
                  componentId: record.componentId,
                  imageName: record.imageName,
                  locationImageName: record.locationImageName,
                  pin: record.pin,
                  componentDescription: record.description,
                  componentAlias: record.alias,
                  category: record.category,
                  partNumber: record.partNumber,
                })
              },
              selectedRowKeys: [
                diagram.detailDiagram.componentNeighbor.data.componentId,
              ],
            }
          }
          size="small"
          rowKey={'componentId'}
          dataSource={neighbors}
          columns={columns}
          pagination={{
            pageSize: pageSize,
            hideOnSinglePage: true,
            current: diagram.detailDiagram.componentNeighbor.table.currentPage,
          }}
          onChange={(pagination, filters, sorter, extra) => {
            dispatch.detailDiagram.handleComponentNeighborTablePageSelection({
              currentPage: pagination.current,
            })
          }}
          loading={isLoading}
          data-testid="component-neighbors-table"
        />
      </Loadable>
    </>
  )
}

export default injectIntl(ComponentNeighbors)
